import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationRuleFormData } from '@/features/notification-rules/schemas/create-notification-rule.schema.ts';

export const usePostNotificationRuleMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: object | undefined) => void;
  } = {
    onSuccess: () => {},
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (notificationRule: NotificationRuleFormData) => {
      return toast.promise(client.post(`/notifications/rules`, notificationRule), {
        loading: 'Creating notification rule...',
        success: 'Successfully created the notification rule.',
        error: (_: unknown) =>
          `Uh oh, there was an error with creating the notification rule.`,
      });
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.(data);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications', 'rules'] });
    },
  });
};
